// en_pms_revenue.ts
// Tłumaczenia dla PMS.Revenue.tsx

export const enPmsRevenue = {

  title: "Revenue Management",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    forecast:          "Forecast & insights",
    demandCalendar:    "Demand calendar",
    activeRestrictions:"Active restrictions",
    eventsImpact:      "Events impact",
    conflictEngine:    "Conflict engine",
    governance:        "Governance",
    derivedRules:      "Derived rules",
    groupsBlocks:      "Groups & blocks",
  },

  // ── Etykiety KPI / tabeli ─────────────────────────────────────────────────
  labels: {
    adrGap:           "ADR gap",
    cancellationRate: "Cancellation rate",
    corporatePickup:  "Corporate pickup",
    behindPace:       "Behind pace",
    onPace:           "On pace",
    base:             "Base",
    active:           "Active",
    corporate:        "Corporate",
    event:            "Event",
    forecast:         "Forecast",
    critical:         "Critical",
  },

} as const;

export default enPmsRevenue;
